import { BasicTenant, Query } from 'graphql/generated/graphqlTypes';
import { generateMockBasicTenant } from 'mocks/graphqlMocks/basicTenant';

export function mockedGetCurrentTenantData(tenant: BasicTenant): Pick<Query, 'getCurrentTenant'> {
  return {
    getCurrentTenant: tenant
  };
}

export const mockedGetCurrentTenantDataForQuery = mockedGetCurrentTenantData(generateMockBasicTenant({}));
